<template>
		<gc-modal condition="true" @cancel="$emit('cancel')">
			<template slot="messageTitle">
				Delete {{deletable}}
			</template>

			<template slot="messageMain">
				Are you sure you want to delete this {{deletable}}<span v-if="!modalParams.noContent"> and all of its contents</span>?
			</template>

			<template slot="messageInfo">
				This cannot be undone
			</template>

			<template slot="footer">
				<a class="gc-modal__cancel" @click="$emit('cancel')">Cancel</a>
				<button class="btn btnRed" @click="confirm" :disabled="buttonDisabled">
					Delete {{deletable}}
				</button>
			</template>
		</gc-modal>
</template>

<script>
	import axios from 'axios'

	export default {
		name: 'DeleteModal',
		components: 'GcModal',
		props: ['modalParams'],
		data () {
			return { buttonDisabled: false };
		},
		created () {
			this.deletable = this.modalParams.deletable;
			this.deletePath = this.modalParams.deletePath;
			this.redirectPath = this.modalParams.redirectPath;
		},
		computed: {
			errorMessage () {
				return 'Could not delete the ' + this.deletable + '. Please try again.';
			}
		},
		methods: {
			confirm () {
				this.buttonDisabled = true;
				let client = axios.create({
					headers: { 'Accept': 'application/json' }
				});

				client
					.delete(this.deletePath)
					.then(this.redirectPage)
					.catch(this.requestError);
			},
			redirectPage () {
				window.location = this.redirectPath;
			},
			requestError () {
				this.$emit('cancel');
				this.$eventHub.$emit('addAlert', {
					type: 'error', message: this.errorMessage
				});
			},
		}
	}
</script>